class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.openingTimer = null;
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.openingTimer) {
      clearTimeout(this.openingTimer);
    }
  }

  handleScroll() {
    const mainContent = document.querySelector('#MainContent');

    if (window.scrollY >= 200) {
      this.classList.add('custom-header--sticky');

      if (window.innerWidth >= 1200) {
        mainContent.style.paddingTop = '60px';
      } else {
        mainContent.style.paddingTop = '48px';
      }

      if (!this.openingTimer) {
        this.openingTimer = setTimeout(() => {
          this.classList.add('custom-header--opening');
          this.openingTimer = null;
        }, 100);
      }
    } else {
      this.classList.remove('custom-header--opening');
      this.classList.remove('custom-header--sticky');

      mainContent.style.paddingTop = '0';

      if (this.openingTimer) {
        clearTimeout(this.openingTimer);
        this.openingTimer = null;
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  customElements.define('custom-header', CustomHeader);
});

// ----------------------------------------------- MegaMenu
class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.activeMenuItem = null;
    this.activeDropdown = null;
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.menuItems = this.querySelectorAll('.mega-menu__item--list');
    this.menuWrappers = this.querySelectorAll('.mega-menu__dropdown');
    this.body = document.body;

    // Create overlay
    this.overlay = document.createElement('div');
    this.overlay.classList.add('mega-menu__overlay');
    document.body.appendChild(this.overlay);

    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', () => this.openMega(menuItem));
      menuItem.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
    });

    this.menuWrappers.forEach(wrapper => {
      wrapper.addEventListener('mouseenter', () => clearTimeout(this.closeTimeout));
      wrapper.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
    });

    this.overlay.addEventListener('mouseenter', () => clearTimeout(this.closeTimeout));
    this.overlay.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));

    this.overlay.addEventListener('mouseenter', () => this.closeMega());
  }

  openMega(menuItem) {
    clearTimeout(this.closeTimeout);

    const dropdown = menuItem.closest('li').querySelector('.mega-menu__dropdown');
    if (!dropdown) return;

    this.menuItems.forEach(item => item.classList.remove('active'));
    this.menuWrappers.forEach(wrapper => {
      if (wrapper !== dropdown) {
        wrapper.classList.remove('active');
      }
    });

    this.activeMenuItem = menuItem;
    this.activeDropdown = dropdown;

    menuItem.classList.add('active');
    dropdown.classList.add('active');
    this.body.style.overflow = 'hidden';
    this.overlay.classList.add('active');
  }

  handleMouseLeave(event) {
    const related = event.relatedTarget;

    if (
      this.activeMenuItem?.contains(related) ||
      this.activeDropdown?.contains(related) ||
      this.overlay?.contains(related)
    ) {
      return;
    }

    this.closeTimeout = setTimeout(() => {
      this.closeMega();
    }, 200);
  }

  closeMega() {
    this.menuItems.forEach(item => item.classList.remove('active'));

    this.menuWrappers.forEach(wrapper => {
      wrapper.classList.remove('active');
    });

    this.body.style.overflow = 'auto';
    this.overlay.classList.remove('active');

    this.activeMenuItem = null;
    this.activeDropdown = null;
  }
}

customElements.define('mega-menu', MegaMenu);

// ----------------------------------------------- Mobile Menu
class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.toggleDrawerBtn = this.querySelector('#openDrawer');
    this.closeDrawerBtn = this.querySelectorAll('.close-drawer');
    this.drawer = this.querySelector('#drawer');
    this.body = document.body;
    this.submenuTriggers = this.querySelectorAll('.mobile-menu__drawer-list-link--child');
    this.isDrawerOpen = false;
    this.submenuBackButtons = this.querySelectorAll('.back-drawer');

    if (this.toggleDrawerBtn) {
      this.toggleDrawerBtn.addEventListener('click', () => this.toggleDrawer());
    }

    if (this.closeDrawerBtn) {
      this.closeDrawerBtn.forEach(btn => {
        btn.addEventListener('click', () => this.toggleDrawer());
      });
    }

    if (this.drawer) {
      this.drawer.addEventListener('click', (e) => {
        if (e.target === this.drawer) {
          this.toggleDrawer();
        }
      });
    }

    this.submenuBackButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSubmenu(button);
      });
    });

    this.submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleSubmenu(trigger);
      });
    });
  }

  toggleDrawer() {
    if (this.isDrawerOpen) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  openDrawer() {
    if (this.drawer) {
      this.resetSubmenus();
      this.drawer.style.display = 'block';
      setTimeout(() => {
        const content = this.drawer.querySelector('.mobile-menu__drawer-content');
        if (content) {
          content.style.transform = 'translateX(0)';
        }
      }, 10);
      this.body.style.overflow = 'hidden';
      this.isDrawerOpen = true;

      this.toggleDrawerBtn.classList.add('is-open');
      this.toggleDrawerBtn.classList.remove('is-closed');
    }
  }

  closeDrawer() {
    const content = this.drawer.querySelector('.mobile-menu__drawer-content');
    if (content) {
      content.style.transform = 'translateX(-100%)';
    }
    this.resetSubmenus();
    setTimeout(() => {
      this.drawer.style.display = 'none';
    }, 300);
    this.body.style.overflow = '';
    this.isDrawerOpen = false;

    this.toggleDrawerBtn.classList.remove('is-open');
    this.toggleDrawerBtn.classList.add('is-closed');
  }

  toggleSubmenu(trigger) {
    const submenu = trigger.nextElementSibling;

    if (submenu && submenu.classList.contains('mobile-menu__drawer-submenu')) {
      submenu.classList.add('is-open');
    }
  }

  closeSubmenu(backButton) {
    const submenu = backButton.closest('.mobile-menu__drawer-submenu');

    if (submenu) {
      submenu.classList.remove('is-open');
    }
  }

  resetSubmenus() {
    const openSubmenus = this.querySelectorAll('.mobile-menu__drawer-submenu.is-open');
    openSubmenus.forEach(submenu => {
      submenu.classList.remove('is-open');
    });
  }

}

customElements.define('mobile-menu', MobileMenu);